import { ChartWidgetMetadata } from '@/modules/ta/legacy/widget/models/metadata/ChartWidgetMetadata';
import { LineChartDrawOption } from '@/modules/ta/legacy/widget/models/drawoptions/LineChartDrawOption';

export class LineChartWidgetMetadata extends ChartWidgetMetadata {
  constructor(model = {}) {
    super(model);

    this.draw_options = new LineChartDrawOption(model.draw_options);
  }
}
